import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToasterService } from 'app/shared/service/toaster.service';
import { QrAttendanceService } from 'shared/service-proxies/services/qr-attendance.service';

@Component({
  selector: 'app-qr-attendance',
  templateUrl: './qr-attendance.component.html',
  styleUrls: ['./qr-attendance.component.scss']
})
export class QrAttendanceComponent implements OnInit, AfterViewInit {

  id: string | null = '';
  currentDate: Date = new Date();
  isConfirmationDialogVisible: boolean = false;
  isMobileDevice: boolean = false;
  ipAddress: string = '';
  employeeDetails: EmployeeBasicDetailsForQrAttendanceDto;

  constructor(
    private activatedRoute: ActivatedRoute,
    private qrAttendanceService: QrAttendanceService,
    private toasterService: ToasterService,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.id = params['id'];  
    });
  }

  ngAfterViewInit(): void {
    this.checkIsMobileDevice();    
  }

  checkIsMobileDevice() {
    const nav = navigator as any;
    if (nav.userAgentData) {
      this.isMobileDevice = nav.userAgentData.mobile;
    } else {
      this.isMobileDevice = window.matchMedia("(max-width: 768px)").matches || navigator.maxTouchPoints > 0;
    }
    //this.isMobileDevice = true; //remove this
    if (this.isMobileDevice) {
      this.getIpAddress();
    }
  }

  getIpAddress() {
    this.qrAttendanceService.getIPAddress().subscribe({
      next: (res) => {
        this.ipAddress = res.trim();
        if (this.ipAddress) {
          this.getEmployeeBasicDetailsForQrAttendance();
        }
      },
      error: (err) => {
        this.toasterService.showApiValidation(err);
      }
    });
  }

  getEmployeeBasicDetailsForQrAttendance() {
    this.qrAttendanceService.getEmployeeBasicDetailsForQrAttendance(this.id, this.ipAddress).subscribe({
      next: (res) => {
        if(res && res.isSuccess) {
          this.employeeDetails = res.responseData;
        }
        else {
          this.isMobileDevice = false;
          this.toasterService.toastError(res.errorMessage);
        }
      },
      error: (err) => {
        this.toasterService.showApiValidation(err);
      }
    });
  }

  showConfirmationDialog() {
    this.isConfirmationDialogVisible = true;
  }

  hideConfirmationDialog() {
    this.isConfirmationDialogVisible = false;
  }

  formatTotalTime(timeSpan: string): string {
    if (!timeSpan) {
      return 'N/A';
    }
    const [hours, minutes, seconds] = timeSpan.split(':');
    return `${hours}h ${minutes}m ${Math.floor(Number(seconds))}s`;
  }

  prepareVerifyQRForAttendanceRequest(): VerifyQRForAttendanceDto {
    const request: VerifyQRForAttendanceDto = {
      cipherText: this.id,
      screenHeight: screen.height,
      screenWidth: screen.width
    }
    return request;
  }

  verifyQRForAttendance() {
    this.qrAttendanceService.verifyQRForAttendance(this.prepareVerifyQRForAttendanceRequest()).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          this.toasterService.toastSuccess(this.employeeDetails.isAlreadyClockIn ? 'Clock out successfully.' : 'Clock in successfully.');
          this.getEmployeeBasicDetailsForQrAttendance();
        }
        else {
          this.toasterService.toastError(res.errorMessage);
        }
        this.hideConfirmationDialog();
      },
      error: (err) => {
        this.hideConfirmationDialog();
        this.toasterService.showApiValidation(err);
      }
    });
  }

}

export interface VerifyQRForAttendanceDto {
  cipherText: string;
  screenWidth: number;
  screenHeight: number;
}

export interface EmployeeBasicDetailsForQrAttendanceDto {
  employeeName: string;
  isAlreadyClockIn: boolean;
  totalWorkTime: string;
  clockInOutDetails: QrAttendanceClockInOutDetailsDto[];
}

export interface QrAttendanceClockInOutDetailsDto {
  clockIn?: Date;
  clockOut?: Date;
  totalTime: string;
}
